// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"styles_infoButton__20hdF","downArrow":"styles_downArrow__1XYTS"};